export default function getDataOrAriaProps(props) {
    return Object.keys(props).reduce(function (prev, key) {
        if ((key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') && key.substr(0, 7) !== 'data-__') {
            prev[key] = props[key];
        }
        return prev;
    }, {});
}


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/_util/getDataOrAriaProps.js
// module id = 447
// module chunks = 0